import { useFeatureFlag } from 'shared/hooks';

export const useSiteMaintenanceDownTime = () => {
  const { isEnabled, variables = {} } = useFeatureFlag('fe-pl-maintenance');
  const {
    routes,
    message = 'We are currently undergoing scheduled maintenance. Please check back shortly. Thank you for your patience!',
    pageTitle = 'Downtime',
    shouldShowDashboardLink,
  } = variables;

  return {
    isMaintenanceDownTime: isEnabled,
    downTimeRoutes: routes ? JSON.parse(routes) : [],
    message,
    pageTitle,
    shouldShowDashboardLink,
  };
};
